// Frontend Application & Payment Status Enums

export enum ApplicationStatus {
  DRAFT = "DRAFT",
  SUBMITTED = "SUBMITTED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}

export enum PaymentStatus {
  PENDING = "PENDING",
  PAID = "PAID",
  VERIFIED = "VERIFIED",
}

export enum PAYMENT_MODE {
  ONLINE = "ONLINE",
  OFFLINE = "OFFLINE",
}

export enum QuartersApplicationStatus {
  DRAFT = "DRAFT",
  SUBMITTED = "SUBMITTED",
  VERIFIED = "VERIFIED",
  APPROVED = "APPROVED",
  RANKED = "RANKED",
  WAITING = "WAITING",
  ALLOTTED = "ALLOTTED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
  EXPIRED = "EXPIRED",
  VACATED = "VACATED",
}

export enum RECRUIMENT_TYPE {
  ALLIED = "ALLIED",
  FACULTY = "FACULTY",
  NON_FACULTY = "NON_FACULTY",
}

// Casing normalization helpers
export function matchStatus(currentStatus: string | undefined, targetStatus: string): boolean {
  if (!currentStatus) return false;
  return currentStatus.trim().toUpperCase() === targetStatus.trim().toUpperCase();
}

export function matchRole(currentRole: string | undefined, targetRole: string): boolean {
  if (!currentRole) return false;
  return currentRole.trim().toUpperCase() === targetRole.trim().toUpperCase();
}

export enum RecruitmentStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
}

export enum AdmissionVacancyStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
}

export enum NoticeStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
}

export enum UserRole {
  APPLICANT = "APPLICANT",
  EMPLOYEE = "EMPLOYEE",
  RECRUITMENT_ADMIN = "RECRUITMENT_ADMIN",
  STUDENT_ADMIN = "STUDENT_ADMIN",
  SUPER_ADMIN = "SUPER_ADMIN",
}

export enum NoticeModule {
  FACULTY_RECRUITMENT = "Faculty Recruitment",
  STUDENT_ADMISSION = "Student Admission",
  NON_FACULTY_RECRUITMENT = "Non-Faculty Recruitment",
}

export enum NoticeType {
  "Advertisement" = "Advertisement",
  "Notice" = "Notice",
  "Circular" = "Circular",
  "Result" = "Result",
}